module.exports = __webpack_public_path__ + "static/media/no-image.dfae51c8.svg";